<div style="height:100%; display: flex; align-items: flex-start; justify-content: center; font-size: 16px; padding-top: 140px;">
  <div style="width: 400px; margin-bottom: 145px;">
    <form [formGroup]="contactForm">
      <div>
        <div style="width: 100%; display: flex; justify-content: center; padding: 15px 0;">
          <img *ngIf="!isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo.svg" />
          <img *ngIf="isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo-dark-theme-3.svg" />
        </div>
        <div style="padding: 36px 0; text-align: center;">
          <span class="fal fa-shield-plus" style="padding-right: 10px;"></span><span style="font-weight: 500;">Account Recovery</span>
          <div *ngIf="state === 'ready'" style="font-size:14px; padding-top: 20px;">Please provide the email address you use to sign into Lexbe.
          </div>
          <div *ngIf="state === 'email-sent'" style="font-size:14px; padding-top: 20px;">We sent instructions to your email to help you sign into your account.</div>
        </div>
        <div *ngIf="state === 'ready'">
          <div>
            <mat-form-field class="full-width gold-outline-2" appearance="outline">
              <input matInput placeholder="Email" formControlName="username" autocomplete="username">
              <mat-error *ngIf="contactForm.controls['username'].hasError('required')">
                Email is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div style="padding: 10px 0;">
            <button style="width: 100%; height: 45px; border-radius: 3px;" mat-raised-button color="primary" (click)="requestForgotPassword()">Send Email
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>